import { render, staticRenderFns } from "./EditNewGroupMerit.html?vue&type=template&id=ca8ddfda&external"
import script from "./EditNewGroupMerit.ts?vue&type=script&lang=ts&external"
export * from "./EditNewGroupMerit.ts?vue&type=script&lang=ts&external"
import style0 from "./EditNewGroupMerit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports